export default {
  messageType: '캐러셀 피드',
  carouselSetting: '캐러셀 설정',
  title: '캐러셀 피드 설정',
  label: {
    feed: '캐러셀 피드 설정',
    title: '제목',
    content: '내용',
    imageLink: '이미지 링크',
  },
  placeholder: {
    imageLink: '이미지 클릭 시 등록한 링크로 이동됩니다.',
  },
  alt: {
    image: '캐러셀 피드 이미지',
  },
  comment: {
    image: '800x400 (2:1 비율) 또는 800x600 (4:3비율) 권장 / 최대 5MB',
  },
  validation: {
    list: {
      max: '캐러셀은 최대 6개까지만 추가할 수 있습니다.',
    },
  },
};
